// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"5a8614b9b90d6d8a","4852":"855fe6a1b4a745ce"}[chunkId] + ".css";
};